import React, { useState, useRef, useEffect } from 'react';
import { Form, Dropdown } from 'react-bootstrap';
import { Filter } from 'react-bootstrap-icons';

const POSFilter = ({ posOptions, selectedPos, onPosChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const togglePos = (pos) => {
    if (selectedPos.includes(pos)) {
      onPosChange(selectedPos.filter((p) => p !== pos));
    } else {
      onPosChange([...selectedPos, pos]);
    }
  };

  const handleClear = () => {
    onPosChange([]);
  };

  return (
    <Dropdown show={isOpen} ref={dropdownRef} className="mb-2 w-100">
      <Dropdown.Toggle 
        variant="outline-secondary" 
        size="sm" 
        className="w-100 d-flex justify-content-between align-items-center"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="text-truncate" style={{ maxWidth: '80%' }}>
          {selectedPos.length === 0 
            ? 'All POS Systems' 
            : `${selectedPos.length} Selected`}
        </div>
        <Filter />
      </Dropdown.Toggle>

      <Dropdown.Menu className="w-100 p-2" style={{ maxHeight: '200px', overflowY: 'auto' }}>
        {posOptions.length === 0 ? (
          <div className="text-muted text-center small py-2">No POS data</div>
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center mb-2 px-2">
              <span className="small fw-bold text-muted">POS Systems</span>
              {selectedPos.length > 0 && (
                <span 
                  className="small text-primary" 
                  style={{ cursor: 'pointer' }} 
                  onClick={handleClear}
                >
                  Clear
                </span>
              )}
            </div>
            {posOptions.map((pos) => (
              <Form.Check 
                key={pos}
                type="checkbox"
                id={`pos-${pos}`}
                label={pos}
                checked={selectedPos.includes(pos)}
                onChange={() => togglePos(pos)}
                className="mb-1 small text-truncate"
                title={pos}
              />
            ))}
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default POSFilter;
